import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.set";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.starts-with";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _typeof from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/typeof";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation, gmTool } from "@/mixins/index";
import channelComMixins from "./mixins/channelComMixins";
import { dailySummary, dailySummaryCurrency } from "@/api/dataPirate/channelData";
import * as echarts from "echarts";
export default {
  mixins: [tabulation, gmTool, channelComMixins],
  name: "accountSummary",
  data: function data() {
    return {
      hour: '01:00',
      searchData: {
        summary_flag: 'd'
      },
      name: 'accountSummary',
      keyVersion: '_v2',
      // 图表渠道切换相关变量
      activeChartChannel: '',
      chartDataMap: {}
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    searchClick: function searchClick() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var reqFn;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                reqFn = _this.currencyClose ? dailySummaryCurrency : dailySummary;
                _this.reqLoading = true;
                _context.next = 4;
                return _this.getexchangeRate();

              case 4:
                _this.searchClickLoop(reqFn, 1);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    /**
       * 全天账号汇总 star
       */
    searchClickNew: function searchClickNew(lists) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var qres, dynamicKeysCollected, formattedTableData, summaryRawList, dynamicHeaderColumns, aggregatedSummary, calculatedSummary, finalSummaryCombined, formattedSummaryRow;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                qres = JSON.parse(JSON.stringify(lists));
                console.log("qres==", qres);
                dynamicKeysCollected = {
                  ltv: new Set(),
                  ac_device_ltv: new Set(),
                  roi: new Set(),
                  rr: new Set(),
                  pay_rr: new Set()
                };
                formattedTableData = [];
                summaryRawList = []; // 收集每天的汇总数据
                // 2. 第一次遍历：解析表格数据，并收集数据中所有出现过的动态 key

                qres.forEach(function (item) {
                  var searchDate = item.searchdate ? item.searchdate.date : '';
                  Object.keys(item).forEach(function (key) {
                    if (key === 'searchdate') return;

                    if (key === '汇总') {
                      summaryRawList.push(item['汇总']);
                    } else {
                      var channelObj = item[key];
                      var innerData = channelObj[searchDate] || {}; // 收集此行数据里的动态 Key

                      _this2.collectDynamicKeys(innerData, dynamicKeysCollected);

                      var calculatedData = _this2.computeExtraFields(innerData);

                      var combinedData = _objectSpread(_objectSpread({}, innerData), calculatedData); // 拍平当前行数据


                      var row = _objectSpread({
                        channel_mark: innerData.channel_mark || key,
                        channel_name: innerData.channel_name || '',
                        hours: searchDate
                      }, _this2.flattenAndFormatObjectData(combinedData));

                      formattedTableData.push(row);
                    }
                  });
                }); // 针对汇总的数据也收集一次动态 key，防止渠道为空的情况

                summaryRawList.forEach(function (summary) {
                  return _this2.collectDynamicKeys(summary, dynamicKeysCollected);
                }); // 3. 根据收集到的动态 key，构建动态表头

                dynamicHeaderColumns = [];
                Object.keys(_this2.dynamicKeyMap).forEach(function (attr) {
                  // 提取 Set 并排序（如 1, 2, 3, 7, 14, 30）
                  var sortedKeys = Array.from(dynamicKeysCollected[attr]).sort(function (a, b) {
                    return Number(a) - Number(b);
                  });
                  sortedKeys.forEach(function (subKey) {
                    dynamicHeaderColumns.push({
                      label: "".concat(_this2.dynamicKeyMap[attr].name).concat(subKey),
                      prop: "".concat(attr, "_").concat(subKey),
                      width: _this2.dynamicKeyMap[attr].width
                    });
                  });
                }); // 4. 组装最终表头配置列表

                _this2.screenListP = [].concat(_toConsumableArray(_this2.baseScreenListP), dynamicHeaderColumns); // if (this.queryCurrency === 'VND') {
                //   this.screenList = this.screenListVND;
                // } else {
                //   this.screenList = this.screenListP;
                // }

                _this2.tableDataList = _this2.screenListP;
                _this2.screen = _this2.screenList.map(function (i) {
                  return i.prop;
                }); // 5. 计算并追加唯一一行“汇总”数据（放在数组最后）

                if (summaryRawList.length > 0) {
                  aggregatedSummary = _this2.calculateFinalSummary(summaryRawList);
                  calculatedSummary = _this2.computeExtraFields(aggregatedSummary);
                  finalSummaryCombined = _objectSpread(_objectSpread({}, aggregatedSummary), calculatedSummary);
                  formattedSummaryRow = _objectSpread({
                    channel_mark: _this2.$t('summaryLabel'),
                    channel_name: _this2.$t('summaryLabel'),
                    hours: '-'
                  }, _this2.flattenAndFormatObjectData(finalSummaryCombined));
                  formattedTableData.push(formattedSummaryRow);
                } // 渲染表格


                _this2.tableData = formattedTableData;

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    collectDynamicKeys: function collectDynamicKeys(dataObj, collectedContainer) {
      Object.keys(collectedContainer).forEach(function (attr) {
        if (dataObj && dataObj[attr] && _typeof(dataObj[attr]) === 'object') {
          Object.keys(dataObj[attr]).forEach(function (key) {
            collectedContainer[attr].add(key);
          });
        }
      });
    },
    computeExtraFields: function computeExtraFields(data) {
      var activeAccount = Number(data.active_account_num || 0);
      var newAccount = Number(data.new_account_num || 0);
      var payAccount = Number(data.pay_account_num || 0);
      var newPayAccount = Number(data.new_pay_account_num || 0);
      var innerIncome = Number(data.inner_purchase_income || 0);
      var newAccountRecharge = Number(data.new_account_recharge_amount || 0); // 1. DOU = 活跃账号 - 新增账号

      var dou = activeAccount - newAccount < 0 ? 0 : activeAccount - newAccount; // 2. POU = 付费账号数 - 新增付费账号数

      var pou = payAccount - newPayAccount < 0 ? 0 : payAccount - newPayAccount; // 3. OPR = POU / DOU

      var opr = dou !== 0 ? pou / dou : 0; // 4. DORPU = (内购付费收入 - 新增账号付费总额) / DOU

      var dorpu = dou !== 0 ? (innerIncome - newAccountRecharge) / dou : 0; // 5. DORPPU = (内购付费收入 - 新增账号付费总额) / POU

      var dorppu = pou !== 0 ? (innerIncome - newAccountRecharge) / pou : 0;
      return {
        dou: dou,
        pou: pou,
        opr: opr,
        dorpu: dorpu,
        dorppu: dorppu
      };
    },

    /**
     * 动态平铺对象字段 (把 ltv: { "1": 10 } 转换成 ltv_1: 10)
     */
    flattenAndFormatObjectData: function flattenAndFormatObjectData(dataObj) {
      var _this3 = this;

      // 1. 先进行拍平
      var flatData = this.flattenObjectData(dataObj);
      var formattedRes = {}; // 2. 字段分类配置
      // 【除以100，保留2位小数】的基础金额字段

      var moneyKeys2 = ['inner_purchase_income', 'total_income', 'active_arpu', 'pay_arppu', 'new_account_recharge_amount', 'new_device_recharge_amount', 'ad_income', 'active_avg_contribution', 'dorpu', 'dorppu']; // 【除以100，保留3位小数】的字段

      var moneyKeys3 = ['new_account_arpu', 'new_pay_account_arppu']; // 【不除以100，直接保留3位小数】的字段

      var directFloat3Keys = ['new_device_account_ratio', 'new_active_ratio']; // 【乘以100 并拼接 %，保留2位小数】的百分比字段

      var percentKeys = ['new_pay_rate', 'opr']; // 3. 遍历格式化

      Object.keys(flatData).forEach(function (key) {
        var val = flatData[key]; // --- 处理动态扩展字段 ---

        if (key.startsWith('ltv_') || key.startsWith('ac_device_ltv_')) {
          // LTV, 激活设备LTV：除以100，保留3位小数
          formattedRes[key] = _this3.formatMoney(val, 3);
        } else if (key.startsWith('roi_')) {
          // ROI：直接保留3位小数
          formattedRes[key] = _this3.formatMoney(val, 3);
        } else if (key.startsWith('rr_') || key.startsWith('pay_rr_')) {
          // RR, 付费账号RR：转换为百分比
          formattedRes[key] = _this3.formatPercent(val);
        } // --- 处理基础字段 ---
        else if (moneyKeys2.includes(key)) {
            formattedRes[key] = _this3.formatMoney(val, 2);
          } else if (moneyKeys3.includes(key)) {
            // 新增账号人均付费，新增付费账号人均付费：除以100，保留3位小数
            formattedRes[key] = _this3.formatMoney(val, 3);
          } else if (directFloat3Keys.includes(key)) {
            // 新增设备账号比，新增活跃比：直接保留3位小数
            formattedRes[key] = _this3.formatDirectFloat(val, 3);
          } else if (percentKeys.includes(key)) {
            formattedRes[key] = _this3.formatPercent(val);
          } else {
            formattedRes[key] = val;
          }
      });
      return formattedRes;
    },
    flattenObjectData: function flattenObjectData(dataObj) {
      var res = _objectSpread({}, dataObj);

      var nestedKeys = ['ltv', 'ac_device_ltv', 'roi', 'rr', 'pay_rr'];
      nestedKeys.forEach(function (attr) {
        if (dataObj[attr] && _typeof(dataObj[attr]) === 'object') {
          Object.keys(dataObj[attr]).forEach(function (subKey) {
            res["".concat(attr, "_").concat(subKey)] = dataObj[attr][subKey];
          });
          delete res[attr];
        }
      });
      return res;
    },
    formatMoney: function formatMoney(val) {
      var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      if (val === undefined || val === null || isNaN(Number(val))) return 0 .toFixed(digits);
      return this.$utils.conversion(val).toFixed(digits);
    },

    /**
     * 直接保留小数工具方法 (不除以100，可自定义小数位数 digits)
     */
    formatDirectFloat: function formatDirectFloat(val) {
      var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
      if (val === undefined || val === null || isNaN(Number(val))) return 0 .toFixed(digits);
      return Number(val).toFixed(digits);
    },

    /**
     * 百分比格式化工具方法 (*100 拼接 %)
     */
    formatPercent: function formatPercent(val) {
      if (val === undefined || val === null || isNaN(Number(val))) return '0.00%';
      return (Number(val) * 100).toFixed(2) + '%';
    },

    /**
     * 汇总数据合并
     */
    calculateFinalSummary: function calculateFinalSummary(summaryList) {
      console.log("summaryList===", summaryList);
      if (!summaryList || !summaryList.length) return {};
      var totalDays = summaryList.length;
      if (totalDays === 1) return JSON.parse(JSON.stringify(summaryList[0])); // 1. 需要直接累加求和的基础数量/金额字段

      var sumKeys = ['inner_purchase_income', // 内购付费收入
      'total_income', // 总收入
      'active_account_num', // 活跃账号
      'new_account_num', // 新增账号
      'non_new_active_account_num', // 非新增活跃账号数
      'pay_account_num', // 付费账号
      'new_device_num', // 新增设备
      'new_account_recharge_amount', // 新增账号付费总额
      'new_pay_account_num', // 新增付费账号数
      'new_device_recharge_amount', // 新增设备付费金额
      'new_device_recharge_num', // 新增设备付费数
      'ad_income', // 广告收入
      'next_day_retain_num', // 次留用户数
      'cost' // 买量消耗
      ];
      var amountNumKeys = ['ltv_amount', 'ac_device_ltv_amount', 'roi_amount', 'rr_num', 'pay_rr_num']; // 初始化结构

      var aggregated = JSON.parse(JSON.stringify(summaryList[0])); // 基础字段清零

      sumKeys.forEach(function (k) {
        aggregated[k] = 0;
      });
      amountNumKeys.forEach(function (attr) {
        aggregated[attr] = {};
      });
      summaryList.forEach(function (current) {
        // 基础字段累加
        sumKeys.forEach(function (k) {
          aggregated[k] += Number(current[k] || 0);
        }); // 动态 amount 和 num 字典累加

        amountNumKeys.forEach(function (attr) {
          if (current[attr] && _typeof(current[attr]) === 'object') {
            Object.keys(current[attr]).forEach(function (subKey) {
              aggregated[attr][subKey] = (aggregated[attr][subKey] || 0) + Number(current[attr][subKey] || 0);
            });
          }
        });
      });
      return this.recomputeDynamicMetrics(aggregated);
    },
    recomputeDynamicMetrics: function recomputeDynamicMetrics(aggregated) {
      console.log("aggregated==", aggregated);
      var sumNewAccount = Number(aggregated.new_account_num || 0);
      var sumNewDevice = Number(aggregated.new_device_num || 0);
      var sumNewPayAccount = Number(aggregated.new_pay_account_num || 0);
      var sumCost = Number(aggregated.cost || 0); // 买量消耗金额
      // 初始化目标嵌套结果

      aggregated.ltv = {};
      aggregated.ac_device_ltv = {};
      aggregated.roi = {};
      aggregated.rr = {};
      aggregated.pay_rr = {}; // --- 1. 计算 LTV: ltv_amount 累加 / 100 / 累加新增账号 ---

      if (aggregated.ltv_amount) {
        Object.keys(aggregated.ltv_amount).forEach(function (subKey) {
          var ltvAmt = Number(aggregated.ltv_amount[subKey] || 0);
          aggregated.ltv[subKey] = sumNewAccount > 0 ? ltvAmt / sumNewAccount : 0;
        });
      } // --- 2. 计算 激活设备LTV: ac_device_ltv_amount 累加 / 100 / 累加新增设备 ---


      if (aggregated.ac_device_ltv_amount) {
        Object.keys(aggregated.ac_device_ltv_amount).forEach(function (subKey) {
          var acDeviceAmt = Number(aggregated.ac_device_ltv_amount[subKey] || 0);
          aggregated.ac_device_ltv[subKey] = sumNewDevice > 0 ? acDeviceAmt / sumNewDevice : 0;
        });
      } // --- 3. 计算 ROI: roi_amount 累加 / 100 / 累加买量消耗cost (若消耗为0直接展示 roi_amount / 100) ---


      if (aggregated.roi_amount) {
        Object.keys(aggregated.roi_amount).forEach(function (subKey) {
          var roiAmt = Number(aggregated.roi_amount[subKey] || 0);
          aggregated.roi[subKey] = sumCost > 0 ? roiAmt / sumCost : roiAmt;
        });
      } // --- 4. 计算 RR: rr_num 累加 / 累加新增账号 ---


      if (aggregated.rr_num) {
        Object.keys(aggregated.rr_num).forEach(function (subKey) {
          var rrNum = Number(aggregated.rr_num[subKey] || 0);
          aggregated.rr[subKey] = sumNewAccount > 0 ? rrNum / sumNewAccount : 0;
        });
      } // --- 5. 计算 付费账号RR: pay_rr_num 累加 / 累加新增付费账号数 ---


      if (aggregated.pay_rr_num) {
        Object.keys(aggregated.pay_rr_num).forEach(function (subKey) {
          var payRrNum = Number(aggregated.pay_rr_num[subKey] || 0);
          aggregated.pay_rr[subKey] = sumNewPayAccount > 0 ? payRrNum / sumNewPayAccount : 0;
        });
      } // --- 6. 重新计算基础均值与比率字段 ---


      var income = Number(aggregated.inner_purchase_income || 0);
      var totalIncome = Number(aggregated.total_income || 0);
      var activeNum = Number(aggregated.active_account_num || 0);
      var payNum = Number(aggregated.pay_account_num || 0);
      var newRecharge = Number(aggregated.new_account_recharge_amount || 0);
      aggregated.new_active_ratio = activeNum ? sumNewAccount / activeNum : 0;
      aggregated.active_arpu = activeNum ? income / activeNum : 0;
      aggregated.pay_arppu = payNum ? income / payNum : 0;
      aggregated.new_device_account_ratio = sumNewAccount ? sumNewDevice / sumNewAccount : 0;
      aggregated.new_pay_rate = sumNewAccount ? sumNewPayAccount / sumNewAccount : 0;
      aggregated.new_account_arpu = sumNewAccount ? newRecharge / sumNewAccount : 0;
      aggregated.new_pay_account_arppu = sumNewPayAccount ? newRecharge / sumNewPayAccount : 0;
      aggregated.active_avg_contribution = activeNum ? totalIncome / activeNum : 0;
      return aggregated;
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('channelId'),
        prop: 'channel_mark'
      }, {
        label: this.$t('channelName'),
        prop: 'channel_name'
      }, {
        label: this.$t('time'),
        prop: 'hours'
      }];
      this.tableDataList.forEach(function (item) {
        columns.push({
          label: item.label,
          prop: item.prop
        });
      });
      var data = this.tableData;
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$t('dailyAccountSummary')
      });
    }
    /**
    * 全天账号汇总 end
    */

  }
};